import React from 'react';
// @mui
import { IconButton, TableCell } from '@mui/material';
import i18n from '../../i18n';
import { extractValues } from '../../utils/formatName';
import { AppDataContext } from '../../context/Context';
import { ContentCopy } from '@mui/icons-material';

const styles = {
    controllerCell: {
        backgroundColor: '#F4F6F8',
        fontWeight: 'bold'
    }
};

export default class GridSelectCombinedCell extends React.Component {
    static contextType = AppDataContext;
    render() {
        const { field, value, row } = this.props;
        let show = this.props.field.show;
        let translate = this.props.field.translate;
        let needStyle = this.props.field.needStyle;
        let displayValue = '';

        if (value) {
            if (show && typeof show === 'string') {
                let parts = show.split('+');
                displayValue = extractValues(value, parts);
                if (value.secondaryName) {
                    displayValue = value.secondaryName + ' - ' + displayValue;
                }
            } else {
                displayValue = value.id;
            }
        }
        // maybe will be added in future
        // const needTranslate = typeof field.needTranslate === 'function'
        //     ? field.needTranslate(value) : true;
        const translatedValue =
            displayValue && translate
                ? i18n.t(`${translate}.${displayValue}`)
                : displayValue;
        const extra =
            typeof field.extraRender === 'function'
                ? field.extraRender(value, row)
                : null;
        const enableCopyExtraRender = field.enableCopyExtraRender;

        const baseStyle = this.props.styles;
        return (
            <TableCell
                key={field.id}
                align="left"
                sx={{ ...(needStyle ? styles.controllerCell : {}), ...baseStyle }}

            >
                <p>{translatedValue}</p>
                {extra && (
                    <p>
                        {extra}
                        {enableCopyExtraRender && (
                            <IconButton
                                size="small"
                                onClick={() =>
                                    navigator.clipboard.writeText(extra)
                                }
                                sx={{
                                    "padding": '0 0 0 2px',
                                    "width": '16px',
                                    "height": '16px',
                                    "color": 'text.secondary',
                                    '& svg': { fontSize: '1rem' }
                                }}
                            >
                                <ContentCopy fontSize="inherit" />
                            </IconButton>
                        )}
                    </p>
                )}
            </TableCell>
        );
    }
}
